import {
  useGetUserTransferActivities,
  useDeleteTransferActivity,
  getGetUserTransferActivitiesQueryKey,
  useGetTopTransferActivities,
  likeTransferActivity,
  unlikeTransferActivity,
  getGetTopTransferActivitiesQueryKey,
} from "@packages/api/madlenAPI";
import { TransferActivityResponseDto } from "@packages/api/madlenAPI.schemas";
import { TransferActivityCard } from "../../components/transfer-activity/TransferActivityCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";

interface ExtendedTransferActivityResponseDto
  extends TransferActivityResponseDto {
  isEditable?: boolean;
}

const TransferActivityDetailComponent = ({
  tool,
}: {
  tool: ExtendedTransferActivityResponseDto;
}) => {
  return (
    <TransferActivityCard
      transferActivity={tool}
      isEditable={tool.isEditable}
    />
  );
};

const TransferActivityView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserTransferActivities}
      useDeleteTool={useDeleteTransferActivity}
      getGetToolsQueryKey={getGetUserTransferActivitiesQueryKey}
      useGetTopTools={useGetTopTransferActivities}
      likeTool={likeTransferActivity}
      unlikeTool={unlikeTransferActivity}
      getGetTopToolsQueryKey={getGetTopTransferActivitiesQueryKey}
      toolType="transferActivities"
      toolPath="transfer-activity"
      DetailComponent={TransferActivityDetailComponent}
      colors={{
        light: "from-[#D98787] to-[#C65151]",
        dark: "dark:from-[#E9A3A3] dark:to-[#D67272]",
        iconBg: "bg-[#FFF6F6] dark:bg-[#4D2828]/30",
        iconColor: "text-[#C15959] dark:text-[#FFB3B3]",
        hover: "hover:bg-[#FFF8F8] dark:hover:bg-[#3D2222]/15",
      }}
      toolColor="[#C15959]"
      gradientColor="ocean"
    />
  );
};

export default TransferActivityView;
